import { registerPlugin } from '@capacitor/core';
const LiveVision = registerPlugin('LiveVision', {
    web: () => import('./web').then((m) => new m.LiveVisionWeb()),
});
export * from './definitions';
export * from './geometry';
export * from './overlay';
export { LiveVision };
//# sourceMappingURL=index.js.map